import React, { ReactElement } from 'react';
import AppLayout from 'components/layouts/AppLayout';
import { getGlobalProps } from 'utils/helpers/server/serverSideProps/global';
import { getPageProps } from 'utils/helpers/server/serverSideProps/ssrProps';
import { getPageNamespaces } from 'utils/helpers/server/serverSideProps/translations';
import { getTranslation, useTranslation } from 'utils/localization';
import { ServerSideInitProps, TNamespaceEnum } from 'types/types';
import DocumentsBlock from 'components/pages/documents/DocumentsBlock';

type Props = Record<string, never>;

interface ServerSideProps {
    props?: Props;
}

const Page = (): ReactElement => {
    const { t } = useTranslation();

    return (
        <AppLayout
            title={getTranslation(t, TNamespaceEnum.navigation, 'pageTitle')}
            pageTitle={{
                primaryBoldText: getTranslation(
                    t,
                    TNamespaceEnum.navigation,
                    'documents'
                ),
                isDark: true,
            }}
            hideUserMenu
            showDisciplineMenu
            hideLoginAs
            changeDisciplineWithoutReload={true}
            showLangMenu={true}
        >
            <DocumentsBlock />
        </AppLayout>
    );
};

export const getServerSideProps = async ({
    req,
    res,
    query,
}: ServerSideInitProps): Promise<ServerSideProps> => {
    const { api } = await getGlobalProps(req, res, true);

    const props = await getPageProps<Props>({
        givenProps: {},
        res,
        req,
        api,
        query,
        loadUserData: false,
        translatePage: true,
        nameSpaces: getPageNamespaces('/navigation/documents'),
    });

    return {
        props,
    };
};

export default Page;
